import firebase from "firebase/app";
import "firebase/firestore";
import { Conference } from "@kaigi100-next/typing";
export const conferenceConverter: firebase.firestore.FirestoreDataConverter<Conference> = {
  toFirestore(conference: Conference): firebase.firestore.DocumentData {
    return conference;
  },
  fromFirestore(
    snapshot: firebase.firestore.QueryDocumentSnapshot,
    options: firebase.firestore.SnapshotOptions
  ): Conference {
    const data = snapshot.data(options);
    return {
      name: data.name,
      externalButton: {
        text: data?.externalButton?.text ?? "",
        link: data?.externalButton?.link ?? "",
      },
      ongoing: {
        screen: data.ongoing.screen,
        sessionName: data.ongoing.sessionName,
        sessionStream: data.ongoing.sessionStream,
        sessionStreamId: data.ongoing.sessionStreamId ?? "",
        sessionId: data.ongoing.sessionId,
        questionId: data.ongoing.questionId,
        commentable: data.ongoing.commentable === "true",
        externalButtonVisibility: data.ongoing.externalButtonVisibility,
        votingExpires: data.ongoing.votingExpires === "true",
        votingExpiresAt: data.ongoing.votingExpiresAt,
        rehearsal: data.ongoing.rehearsal || false,
        projector: {
          forceScreen: data.ongoing?.projector?.forceScreen || "NONE",
        },
      },
      commentVisibility: data.commentVisibility ?? "ALLOW_ALL",
      viewerNameFieldOption: data.viewerNameFieldOption,
      pollOption: {
        confirm: data.pollOption?.confirm ?? true,
        showResultsToViewer: data.pollOption?.showResultsToViewer ?? false,
        creatablePollType: data.pollOption?.creatablePollType ?? "ONLY_POLL",
        timeOut: data.pollOption?.timeOut ?? false,
      },
      surveyOption: {
        skip: data.surveyOption?.skip ?? false,
      },
      streamingSetting: {
        publishingContentStreamId:
          data.streamingSetting?.publishingContentStreamId ?? "",
        layout: data.streamingSetting?.layout ?? "WEBCAM_AND_CONTENT",
      },
      signInProvider: data.signInProvider ?? "ANONYMOUS",
      loginFailedErrorMessage: data.loginFailedErrorMessage ?? "",
    };
  },
};
